import { MouseEvent } from 'react'
import { useAppSelector } from '../../../common/hooks'
import { dispatch } from '../../../store'
import { missionProgressModalActions } from '../../../store/slices/missionProgressModal'
import { sessionActions } from '../../../store/slices/session'
import { PreSignupModal } from '../PreSignupModal'

export const CreateAccountButton = () => {
  const merchantCode = useAppSelector((state) => state.session.merchantCode)

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    dispatch(missionProgressModalActions.setIsOpen(false))

    if (!merchantCode) {
      dispatch(sessionActions.hideModal())
      setTimeout(() => {
        dispatch(sessionActions.showSignupModal(true))
        dispatch(sessionActions.setSignupWidget(true))
      }, 0)
    }
  }

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          backgroundColor: '#FF7A00',
          color: 'white',
          fontWeight: 'bold',
          padding: '7px 15px',
          borderRadius: '8px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '14px',
        }}
      >
        Cadastrar Agora
      </button>
      {!merchantCode && <PreSignupModal />}
    </>
  )
}
